package com.evoapps.evoshift.domain.usecase.auth

import com.evoapps.evoshift.domain.model.User
import com.evoapps.evoshift.domain.repository.AuthRepository
import kotlinx.coroutines.flow.Flow

class GetCurrentUserUseCase(
    private val authRepository: AuthRepository
) {
    /**
     * Zwraca Flow, który emituje aktualnego usera (lub null).
     * Reaguje na zmiany w profilu (np. zmiana avatara, zmiana roli w firmie).
     */
    operator fun invoke(): Flow<User?> {
        return authRepository.observeCurrentUser()
    }
}